// Copyright (c) 2016 Deere & Company

import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import moment from 'moment';

export const getDefaultState = () =>
    new DateRange({
        from: moment
            .utc()
            .startOf('day')
            .subtract(2, 'year')
            .valueOf(),
        max: moment
            .utc()
            .endOf('day')
            .valueOf(),
        min: moment
            .utc()
            .startOf('day')
            .subtract(10, 'year')
            .valueOf(),
        to: moment
            .utc()
            .endOf('day')
            .valueOf()
    });



// WEBPACK FOOTER //
// ./src/reports/registrations-review/state/date-range.js